// extracted by mini-css-extract-plugin
export default {"wrapper":"ww7m9hiJU1zI8AY_TAIp"};